import { useQuery } from "@tanstack/react-query";
import {
  normalizeParticipantListItem,
  parseParticipantsList,
  parseParticipantsPagination,
} from "./helpers";

async function getParticipantsOld({
  callApiWithWorker,
  lang,
  pageIndex,
  pageSize,
  status,
  signal,
}) {
  const params = new URLSearchParams({
    lang,
    page: pageIndex,
    size: pageSize,
  });

  if (status) params.set("status", status);

  const url = `/participants?${params.toString()}`;

  const res = await callApiWithWorker(url, {
    method: "GET",
    connector: "springConnector",
    signal,
  });

  const raw = parseParticipantsList(res);
  const normalized = raw.map(normalizeParticipantListItem);
  const normalizedStatus = String(status ?? "")
    .trim()
    .toLowerCase();
  const content = normalizedStatus
    ? normalized.filter(
        (participant) =>
          String(participant?.status ?? "")
            .trim()
            .toLowerCase() === normalizedStatus,
      )
    : normalized;

  const pagination = parseParticipantsPagination(res, content.length);
  const adjustedTotal = normalizedStatus
    ? content.length
    : pagination.totalElements;

  return {
    content,
    totalElements: adjustedTotal,
    page: pagination.page,
    size: pagination.size,
    pages: pagination.pages,
    message: pagination.message,
  };
}

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string} deps.lang
 * @param {number} deps.pageIndex
 * @param {number} deps.pageSize
 * @param {string | undefined | null} [deps.status]
 */
export function useGetParticipantsOld({
  callApiWithWorker,
  lang,
  pageIndex,
  pageSize,
  status,
}) {
  return useQuery({
    queryKey: ["participants", lang, pageIndex, pageSize, status ?? null],
    queryFn: ({ signal }) =>
      getParticipantsOld({
        callApiWithWorker,
        lang,
        pageIndex,
        pageSize,
        status,
        signal,
      }),
    enabled:
      Boolean(callApiWithWorker) &&
      Boolean(lang) &&
      Number.isInteger(pageIndex) &&
      Number.isInteger(pageSize),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
